module.exports = __webpack_public_path__ + "img/464445_D2D0CB_919196_A8ADB0-256px.d52569a8.png";